import { render, staticRenderFns } from "./widget_coaching_portal.vue?vue&type=template&id=71e6c3a8&"
import script from "./widget_coaching_portal.vue?vue&type=script&lang=js&"
export * from "./widget_coaching_portal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports